import { config } from '@pro/linearTopLight/config';
import styles from '@app/linearTopLight/page.module.less';
import { TopBanner } from '@app/linearTopLight/TopBanner';
import { KeyFeatures } from 'components/linearTopLight/KeyFeatures';
import { EfficiencyBanner } from '@app/linearTopLight/EfficiencyBanner';
import { FarRed } from '@app/linearTopLight/FarRed';
import { OptimizedSpectra } from '@app/linearTopLight/OptimizedSpectra';
import { GreenhouseOptimized } from '@app/linearTopLight/GreenhouseOptimized';

const Page: Globals.NextPage = () => {
    return (
        <div className={styles.page}>
            <TopBanner data={config.topBanner}/>
            <KeyFeatures data={config.keyFeatures}/>
            <EfficiencyBanner data={config.efficiencyBanner}/>
            <FarRed data={config.farRed}/>
            <OptimizedSpectra data={config.optimizedSpectra}/>
            <GreenhouseOptimized data={config.greenhouseOptimized}/>
        </div>
    )
};

export default Page;